import { render } from "./StopIcon.vue?vue&type=template&id=124e65e6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/StopIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "124e65e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('124e65e6', __exports__)) {
    api.reload('124e65e6', __exports__)
  }
  
  module.hot.accept("./StopIcon.vue?vue&type=template&id=124e65e6", () => {
    api.rerender('124e65e6', render)
  })

}


export default __exports__